import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { Fragment, useRef, useMemo, useEffect, useState } from 'react';
import { document, ResizeObserver } from '../../helpers/BrowserHelpers';

var getWidth = function getWidth(container) {
  return container.getBoundingClientRect().width;
};

var Wrapper = function Wrapper(_ref) {
  var containerId = _ref.containerId,
      children = _ref.children;
  var innerEditorObserver = useRef();
  var container = useMemo(function () {
    return containerId ? document.getElementById(containerId) : document.body;
  }, [containerId]);

  var _useState = useState(getWidth(container)),
      _useState2 = _slicedToArray(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      innerWidth = _useState4[0],
      setInnerWidth = _useState4[1];

  var observer = useMemo(function () {
    return new ResizeObserver(function (entries) {
      if (entries.length === 1) {
        var _width = entries[0].contentRect.width;
        setWidth(_width);

        if (innerEditorObserver.current) {
          setInnerWidth(innerEditorObserver.current.clientWidth);
        }
      }
    });
  }, []);
  useEffect(function () {
    observer.observe(container);
    return function () {
      return observer.unobserve(container);
    };
  }, [observer, container]);
  return React.createElement(Fragment, null, children, React.createElement("style", null, "\n        :root {\n          --editor-container-width: ".concat(width, "px;\n          --editor-inner-width: var(--note-editor-max-width);\n          ").concat(innerWidth && "--editor-inner-width: ".concat(innerWidth, "px;"), "\n        }\n      ")), React.createElement("div", {
    "data-editor-width-observer": true,
    ref: innerEditorObserver
  }));
};

export default React.memo(Wrapper);